/**
 * DevExtreme (viz/tree_map.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./tree_map/tree_map");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/viz/tree_map.js
// module id = ../../../../devextreme/viz/tree_map.js
// module chunks = 3